import moment from "moment";

const RescheduledChefitBanner = ({ record }: { record: any }) => {
  if (record?.status !== "RESCHEDULED") return null;

  return (
    <div
      style={{
        backgroundColor: "#EFF6FF",
        border: "1px solid #BFDBFE",
        borderRadius: "8px",
        padding: "10px 14px",
        marginBottom: "10px",
        display: "flex",
        gap: "10px",
        alignItems: "flex-start",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#DBEAFE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#1D4ED8",
          fontWeight: 700,
          fontSize: "15px",
          flexShrink: 0,
          marginTop: "1px",
        }}
      >
        ↻
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        {/* Line 1: title + key fields inline */}
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center", fontSize: "13px" }}>
          <span style={{ fontSize: "14px", fontWeight: 600, color: "#1E40AF" }}>
            Chefit Rescheduled
          </span>

          {record?.rescheduledAt && (
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Rescheduled At:</span>{" "}
              <span style={{ color: "#1E40AF" }}>{moment(record.rescheduledAt).format("DD/MM/YYYY hh:mm A")}</span>
            </div>
          )}

          {(record?.rescheduleReason || record?.rescheduleReasons) && (
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Reason:</span>{" "}
              <span style={{ color: "#1E40AF" }}>{record?.rescheduleReason || record?.rescheduleReasons}</span>
            </div>
          )}

          {record?.rescheduledBy && (
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Rescheduled By:</span>{" "}
              {record?.rescheduledByType === "ADMIN" ? (
                <a
                  href={`/#/AdminUsers/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : record?.rescheduledByType === "COOK" ? (
                <a
                  href={`/#/Cooks/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : record?.rescheduledByType === "CUSTOMER" ? (
                <a
                  href={`/#/Customers/${record.rescheduledBy}/show`}
                  style={{ color: "#1D4ED8", textDecoration: "underline" }}
                >
                  #{record.rescheduledBy}
                </a>
              ) : (
                <span style={{ color: "#1E40AF" }}>#{record.rescheduledBy}</span>
              )}
              {record?.rescheduledByType && (
                <span style={{ color: "#6B7280", marginLeft: "6px", fontSize: "12px" }}>
                  ({record.rescheduledByType})
                </span>
              )}
            </div>
          )}
        </div>

        {/* Line 2: sub reason — only if present */}
        {record?.rescheduleSubReason && (
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "center", fontSize: "13px", marginTop: "5px", paddingTop: "5px", borderTop: "1px solid #BFDBFE" }}>
            <div>
              <span style={{ color: "#1E3A8A", fontWeight: 500 }}>Sub Reason:</span>{" "}
              <span style={{ color: "#1E40AF" }}>{record.rescheduleSubReason}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RescheduledChefitBanner;
